import { GalleryIcon } from 'src/components/Icons/GalleryIcon'

interface Props {
  numberOfImages: number
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openGalleryView: (image: number, event: { target: any }) => void
  activeImage?: number
  compact?: boolean
}

export const ButtonMorePictures = ({
  numberOfImages,
  openGalleryView,
  activeImage,
  compact = false,
}: Props) => {
  return (
    <button
      className={
        compact
          ? 'text-font-size-2 text-restructure-primary font-medium rounded-round px-2 py-1 outline-none flex items-center justify-center bg-restructure-background-primary/90'
          : 'text-font-size-2 text-restructure-primary font-medium rounded-round px-sm py-1.5 outline-none flex w-full items-center justify-center gap-1.5 bg-restructure-background-primary'
      }
      onClick={(event) => {
        openGalleryView(0, event)
      }}
      data-testid="button-more-pictures"
      aria-label="Ver mais fotos"
      value="Ver mais fotos"
    >
      {!compact && <GalleryIcon />}
      {activeImage
        ? `${activeImage}/${numberOfImages}`
        : `${numberOfImages} fotos`}
    </button>
  )
}
